




import React from 'react'
import './AcademicSupport.css'




const AcademicSupport:React.FC = () => {

  return (
   <>
   
   <div className="w-screen overflow-hidden p-4 min-h-screen custom-academic-container">
    <div className=' flex flex-col items-center justify-center mx-auto max-w-[800px]'>
        <div className=' sm:text-lg md:text-xl lg:text-3xl xl:text-4xl text-black  font-sans'><h3>Scholarships Academic Support</h3></div>
        <div className=' text-center font-sans w-[80%] p-10'>
          <p>At Next Play Nation, we understand that navigating the path to college can be challenging, 
            especially when it comes to scholarships and academic support. That’s why we’re committed to guiding athletes 
            through every step of the journey—on and off the field. Whether you’re
             unsure where to start or need help staying on track, our team provides mentorship, educational resources,
              and one-on-one support to help you pursue scholarship opportunities and achieve academic success. 
              Your talent deserves a future, and we’re here to help you reach it.</p></div>




    </div>


   </div>
   
   
   
   
   </>
  )
}

export default AcademicSupport
